export default "__VITE_ASSET__BumiQn3i__"